module.exports = __webpack_public_path__ + "static/media/hero-phone-11.cb280424.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/winter-2019/hero-phone-11.png
// module id = 160
// module chunks = 0